import React from 'react'
import TemplateList from '../common/TemplateList'
import ClinicEmailTemplate from './ClinicEmailTemplate'

function EmailDashboard() {
  return (
    <div className="container container-xxl">
      <div className="row">
          <div className="col-6">
              <TemplateList type="email"/>
          </div>
          <div className="col-6">
            <ClinicEmailTemplate/>
          </div>
      </div>
    </div>
  )
}

export default EmailDashboard